import type { OpportunityList } from '../../../domain/list';
import { queryClient } from '../../../queryClient';
import type { AppStore } from '../../../services/appStore';
import { translate } from '../../../services/i18n';
import { opportunityListsApi } from '../api';
import opportunityListQueryKey from '../opportunityListQuery/opportunityListQueryKey';

import type { SaveDomainToListRepository } from './useCase';

export const makeSaveDomainToListRepository = (appStore: AppStore): SaveDomainToListRepository => ({
  createList: (name: string) => opportunityListsApi.createOpportunityList(name),
  saveDomainToList: ({ domain, id }: { domain: string; id: string }) => opportunityListsApi.saveToList({ domain, id }),
  notifySaveToListSucceed: () => {
    appStore.setSuccessToast({
      content: translate('company.save_to_list.success'),
    });
  },
  notifySaveToListFailed: () => {
    appStore.setErrorToast({
      content: translate('company.save_to_list.failed'),
    });
  },
  addListToRepository(list: OpportunityList) {
    const queryKey = opportunityListQueryKey.list();
    queryClient.setQueryData<OpportunityList[]>(queryKey, (queryData: OpportunityList[] | undefined) =>
      (queryData || []).concat(list)
    );
  },
  updateListAndCount({ domain, id }: { domain: string; id: string }) {
    const listQueryKey = opportunityListQueryKey.list();

    queryClient.setQueryData<OpportunityList[] | undefined>(
      listQueryKey,
      (listQueryData: OpportunityList[] | undefined) => {
        return (
          listQueryData?.map((list) => (list.id === id ? { ...list, domains: [...list.domains, domain] } : list)) || []
        );
      }
    );
  },
});
